/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["voxel-loading[_ngcontent-%COMP%]     .loader{height:100vh;display:flex;align-items:center}voxel-loading[_ngcontent-%COMP%]     .loader .loader-ios .varejo{background-color:grey}main[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between}main[_ngcontent-%COMP%]     .vcl-button-text.vcl-button{font-family:\"Itau Display\";font-weight:700}"];
export { styles as styles };
